export const paymentYears = payment => {
  if (payment.years != null) return payment.years;
  if (payment.months) return (payment.months / 12).toFixed(1);
  return '—';
};

export const paymentEmailMessage = result => {
  if (result.emailSent) return ` Receipt emailed to ${result.emailTo}.`;
  if (result.emailTo) return ' Receipt email could not be sent.';
  return ' No admin email on file — no receipt sent.';
};

export const paymentValues = (form, shop) => {
  const years = Number(form.years) || 1;
  return { years, amount: form.amount === '' ? Number(shop?.yearlyFee) * years : Number(form.amount) };
};

export const paymentContext = (data, shop) => {
  const info = shop && data?.shop?.id === shop.id ? data : null;
  return { info, currentShop: info?.shop || shop };
};